export class Init {
  static readonly type = 'init';
}

export class Clear {
  static readonly type = 'clear';
}
